export default __webpack_public_path__ + "static/media/logo.a3d81f8a.png";